angular.module('lf.common')

.directive('validCreditCardNumber', function (validationService) {
  return {
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
      var valid = model.$isEmpty(val) || validationService.creditCard.validateCreditCardNumber(val);
        model.$setValidity('checkCC', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
